"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var base64_1 = require("./base64");
var fabric_2 = require("./fabric");
/**
 * Rasterize given svg to PNG or JPEG bitmap image.
 */
function svg2png(options) {
    return __awaiter(this, void 0, void 0, function () {
        var canvas, data, img, s;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options.debug && console.log("Options: " + JSON.stringify(__assign({}, options, { input: null })));
                    canvas = new fabric_1.fabric.Canvas('c');
                    data = typeof options.input === 'string' ? options.input : options.input.toString();
                    return [4 /*yield*/, fabric_2.fabricImageFromData(data, 'svg')];
                case 1:
                    img = _a.sent();
                    canvas.add(img);
                    s = canvas.toDataURL(__assign({ height: img.height, width: img.width }, options, { format: options.format || 'png' }));
                    if (options.encoding === 'dataURL') {
                        return [2 /*return*/, s];
                    }
                    else if (options.encoding === 'base64') {
                        return [2 /*return*/, base64_1.urlToBase64(s)];
                    }
                    else if (options.encoding === 'buffer') {
                        return [2 /*return*/, Buffer.from(base64_1.urlToBase64(s), 'base64')];
                    }
                    else {
                        return [2 /*return*/, base64_1.urlToData(s)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.svg2png = svg2png;
//# sourceMappingURL=svg2png.js.map